import { FilterOperator } from '../modules/app';

export const FILTER_OPERATOR: { [key: string]: FilterOperator } = {
  AND: 'AND',
  OR: 'OR',
};
